import { React, useContext } from 'react';

import { Outlet, Navigate } from 'react-router-dom';

import DadosUsuario from '../utils/context';

const ProtectedRoute = (props) => {
    const dadosUsuario = useContext(DadosUsuario);
    const autorizacoes = dadosUsuario.autorizacoes;

    const hasRole = props.role ? autorizacoes.includes(props.role) : false;
    const hasAnyRole = props.roles ? props.roles.some((role) => autorizacoes.includes(role)) : false;
    const hasRoleIncludes = props.roleIncludes
        ? props.roleIncludes.some((role) => autorizacoes.some((autorizacao) => autorizacao.includes(role)))
        : false;
    const isAuth = hasRole || hasAnyRole || hasRoleIncludes || autorizacoes.includes('Adm');

    return isAuth ? <Outlet {...props} /> : <Navigate to='/403-Unauthorized' />;
};

export default ProtectedRoute;
